import React from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import moment from 'moment';

export default function ComponentTrnInfo(props) {

    function getRoundOff(data) {
        const finalTotal = (data.total - data.discount) + data.tax;
        const roundedTotal = Math.round(finalTotal);
        const roundOffValue = (roundedTotal - finalTotal).toFixed(2);
        if (roundOffValue === "0.00") {
            return roundOffValue;
        }
        return roundOffValue > 0 ? `+${roundOffValue}` : roundOffValue;
    }

    return (
        <div className='overflow-y-auto overflow-x-hidden z-[100] w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
            <div className='bg-white w-[600px] min-h-screen absolute right-0 p-[20px]'>
                <ScrollArea>
                    <div className='px-2'>
                        <div className='flex items-center justify-between text-2xl'>
                            <h1 className='font-sans font-medium text-gray-900 uppercase'>TRN #{props.record.trnid}</h1>
                            <div className='w-7 h-7 text-gray-700 flex items-center justify-center border border-black rounded-full hover:bg-black hover:text-white cursor-pointer' onClick={() => { props.onClose(); }}>
                                <span><i className="las la-times text-xl cursor-pointer"></i></span>
                            </div>
                        </div>
                        <div className='mt-2'>
                            Timestamp: <b>{moment(props.record.createdAt).format('DD MMM, yyyy hh:mm:ss A')}</b>
                        </div>
                        <hr className='my-2' />
                        <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-4 flex justify-between items-center'>
                            <span className='flex items-center'>
                                <i className="las la-file-invoice mr-2 text-xl"></i>Transactions Summery
                            </span>
                        </div>
                        <div className='mt-4 flex items-center'>
                            <p className='text-sm font-bold text-gray-950'>Particulars</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-bold text-gray-950'>ID</p>
                        </div>
                        <hr className='my-2' />
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Organization Info</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>#{props.record.ordid.ordid}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Subscription Info</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>#{props.record.subid.subid}</p>
                        </div>
                        <hr className='my-2' />
                        <div class="w-full mt-2 space-y-1">
                            <div class="flex justify-between">
                                <span class="font-medium text-sm">Subtotal</span>
                                <span class="font-medium text-sm">₹ {props.record.total.toFixed(2)}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="font-medium text-sm">Discount (-)</span>
                                <span class="font-medium text-sm">₹ {props.record.discount.toFixed(2)}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="font-medium text-sm">CGST(2.5%)</span>
                                <span class="font-medium text-sm">₹ {(props.record.tax / 2).toFixed(2)}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="font-medium text-sm">SGST(2.5%)</span>
                                <span class="font-medium text-sm">₹ {(props.record.tax / 2).toFixed(2)}</span>
                            </div>
                            <div class="flex justify-between">
                                <span class="font-medium text-sm">Round off</span>
                                <span class="font-medium text-sm">₹ {getRoundOff(props.record)}</span>
                            </div>
                            <div class="border-t-2 mt-2 py-2 flex items-center justify-between">
                                <span class="font-medium text-lg">Grand Total</span>
                                <span class="font-medium text-lg">₹ {Math.round((props.record.total - props.record.discount) + props.record.tax).toFixed(2)}</span>
                            </div>
                        </div>
                        <div className='p-2 bg-gray-200 w-full text-sm font-medium rounded mt-2 flex justify-between items-center'>
                            <span className='flex items-center'>
                                <i className="las la-file-invoice mr-2 text-xl"></i>Payment Summery
                            </span>
                        </div>
                        <div className='mt-4 flex items-center'>
                            <p className='text-sm font-bold text-gray-950'>Particulars</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-bold text-gray-950'>ID</p>
                        </div>
                        <hr className='my-2' />
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Payment Mode</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium uppercase'>{props.record.pmode.mode}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Payment Ref</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium'>{props.record.pmode.ref}</p>
                        </div>
                        <div className='flex items-center'>
                            <p className='text-sm  font-medium text-gray-950'>Status</p>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-medium uppercase'>{props.record.status}</p>
                        </div>
                        <hr className='my-2' />
                    </div>
                </ScrollArea >
            </div >
        </div >
    )
}
